module.exports = __webpack_public_path__ + "img/episode5.6a9b234e.png";